var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "label space" }, [_vm._v("Dados do imóvel")]),
      _c(
        "el-row",
        { staticClass: "marginBotton", attrs: { type: "flex", gutter: 30 } },
        [
          _vm.isOnerosoNaoOneroso
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Gleba do Imóvel:",
                                  required: true
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: { name: "Gleba" },
                                model: {
                                  value: _vm.dadosImovel.gleba,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dadosImovel, "gleba", $$v)
                                  },
                                  expression: "dadosImovel.gleba"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1349532923
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isOnerosoNaoOneroso ? "required" : "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Bairro/Povoado:",
                            required: _vm.isOnerosoNaoOneroso
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Povoado" },
                          model: {
                            value: _vm.dadosImovel.povoado,
                            callback: function($$v) {
                              _vm.$set(_vm.dadosImovel, "povoado", $$v)
                            },
                            expression: "dadosImovel.povoado"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.isReurbIndividual
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Logradouro do Imóvel:", required: false }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { name: "Povoado" },
                    model: {
                      value: _vm.dadosImovel.logradouro,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "logradouro", $$v)
                      },
                      expression: "dadosImovel.logradouro"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isOnerosoNaoOneroso ? "required" : "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Município do Imóvel:",
                            required: _vm.isOnerosoNaoOneroso
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "full-width input",
                            class: { erro: errors.length },
                            attrs: { filterable: "filterable" },
                            model: {
                              value: _vm.dadosImovel.municipio,
                              callback: function($$v) {
                                _vm.$set(_vm.dadosImovel, "municipio", $$v)
                              },
                              expression: "dadosImovel.municipio"
                            }
                          },
                          _vm._l(_vm.municipios, function(municipio) {
                            return _c("el-option", {
                              key: municipio.id,
                              attrs: {
                                label: municipio.nome,
                                value: municipio.id
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.isReurbIndividual
        ? _c(
            "el-row",
            {
              staticClass: "marginBotton",
              attrs: { type: "flex", gutter: 30 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Número de controle:" }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: { name: "numeroDeControle" },
                                model: {
                                  value: _vm.dadosImovel.numeroDeControle,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dadosImovel,
                                      "numeroDeControle",
                                      $$v
                                    )
                                  },
                                  expression: "dadosImovel.numeroDeControle"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2287687404
                    )
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Quadra de controle:" }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: { name: "quadraDeControle" },
                                model: {
                                  value: _vm.dadosImovel.quadraDeControle,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dadosImovel,
                                      "quadraDeControle",
                                      $$v
                                    )
                                  },
                                  expression: "dadosImovel.quadraDeControle"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      896622879
                    )
                  })
                ],
                1
              ),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "inputArea" },
                  [
                    _c(
                      "div",
                      [
                        _c("app-label", {
                          attrs: { label: "Área:", required: false }
                        }),
                        _c("app-double-input", {
                          staticClass: "input",
                          attrs: {
                            name: "Área",
                            precision: 4,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: false
                          },
                          model: {
                            value: _vm.dadosImovel.areaOrigin,
                            callback: function($$v) {
                              _vm.$set(_vm.dadosImovel, "areaOrigin", $$v)
                            },
                            expression: "dadosImovel.areaOrigin"
                          }
                        }),
                        _vm.dadosImovel.areaOrigin && _vm.dadosImovel.tipoArea
                          ? _c("p", { staticClass: "conversao" }, [
                              _vm._v(
                                "Conversão: " +
                                  _vm._s(_vm.conversaoAreaCadastro())
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div"),
                    _c("validation-provider", {
                      attrs: {
                        rules:
                          _vm.isMa &&
                          _vm.dadosImovel.areaOrigin &&
                            _vm.dadosImovel.areaOrigin !== 0
                            ? "required"
                            : ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Tipo:", required: false }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "input select",
                                    attrs: {
                                      placeholder: "Selecione",
                                      filterable: "filterable",
                                      clearable: "clearable",
                                      "value-key": "id",
                                      name: "Tipo",
                                      disabled: _vm.isMa
                                        ? !_vm.dadosImovel.areaOrigin ||
                                          _vm.dadosImovel.areaOrigin === 0
                                        : false
                                    },
                                    on: {
                                      clear: function($event) {
                                        _vm.dadosImovel.tipoArea = null
                                      }
                                    },
                                    model: {
                                      value: _vm.dadosImovel.tipoArea,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dadosImovel,
                                          "tipoArea",
                                          $$v
                                        )
                                      },
                                      expression: "dadosImovel.tipoArea"
                                    }
                                  },
                                  _vm._l(_vm.tiposArea, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.nome,
                                        value: item.codigo
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4183199426
                      )
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.isOnerosoNaoOneroso
        ? _c(
            "el-row",
            {
              staticClass: "marginBotton",
              attrs: { type: "flex", gutter: 30 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Matrícula:", required: false }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { name: "Matrícula" },
                    model: {
                      value: _vm.dadosImovel.matricula,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "matricula", $$v)
                      },
                      expression: "dadosImovel.matricula"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Livro:", required: false }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { name: "Livro" },
                    model: {
                      value: _vm.dadosImovel.livro,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "livro", $$v)
                      },
                      expression: "dadosImovel.livro"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Folha:", required: false }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { name: "Folha" },
                    model: {
                      value: _vm.dadosImovel.folha,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "folha", $$v)
                      },
                      expression: "dadosImovel.folha"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isOnerosoNaoOneroso
        ? _c(
            "el-row",
            {
              staticClass: "marginBotton",
              attrs: { type: "flex", gutter: 30 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Cartório:", required: false }
                  }),
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { name: "Cartório" },
                    model: {
                      value: _vm.dadosImovel.cartorio,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "cartorio", $$v)
                      },
                      expression: "dadosImovel.cartorio"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Município do Cartório:", required: false }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width input",
                      attrs: { filterable: "filterable" },
                      model: {
                        value: _vm.dadosImovel.municipioCartorio,
                        callback: function($$v) {
                          _vm.$set(_vm.dadosImovel, "municipioCartorio", $$v)
                        },
                        expression: "dadosImovel.municipioCartorio"
                      }
                    },
                    _vm._l(_vm.municipios, function(municipio) {
                      return _c("el-option", {
                        key: municipio.id,
                        attrs: { label: municipio.nome, value: municipio.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Latitude:", required: false }
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##°##'##,###\"A"],
                        expression: "[`##°##'##,###\"A`]"
                      }
                    ],
                    staticClass: "input",
                    attrs: { name: "Latitude" },
                    model: {
                      value: _vm.dadosImovel.latitude,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "latitude", $$v)
                      },
                      expression: "dadosImovel.latitude"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isOnerosoNaoOneroso
        ? _c(
            "el-row",
            {
              staticClass: "marginBotton",
              attrs: { type: "flex", gutter: 30 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Longitude:", required: false }
                  }),
                  _c("el-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##°##'##,###\"A"],
                        expression: "[`##°##'##,###\"A`]"
                      }
                    ],
                    staticClass: "input",
                    attrs: { name: "Longitude" },
                    model: {
                      value: _vm.dadosImovel.longitude,
                      callback: function($$v) {
                        _vm.$set(_vm.dadosImovel, "longitude", $$v)
                      },
                      expression: "dadosImovel.longitude"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66bf1cbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66bf1cbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppFormularioAnaliseDadosImovel.vue
// module id = null
// module chunks = 